/**
 * MediaQuery allows for registering MediaQueryList objects with
 * varying media queries.
 *
 * @author Alex Nakorn (anakorn@blizzard.com)
 */

(function(window, overwatch, Utilities){

    var MediaQuery = function() {

    	/**
    	 * MediaQueryList cache.
    	 *
    	 * @type {Object}
    	 * @see https://developer.mozilla.org
    	 * 		/en-US/docs/Web/Guide/CSS/Testing_media_queries
    	 */
    	var mqlCache = {};

    	/**
    	 * Default configuration for MediaQuery.
    	 *
    	 * @type {Object}
    	 */
    	var config = {
    		defaultMediaQuery: "(max-width: 760px)"
    	};

    	/**
    	 * Registers a callback on orientationchange events.
    	 *
    	 * @param  {Function} cb - Callback function to be called on event trigger
    	 */
    	function onOrientationChange(cb) {
    		window.addEventListener("orientationchange", cb);
    	}

    	/**
    	 * Registers a callback on a MediaQueryList called when a media query
    	 * is matched.
    	 *
    	 * @param  {MediaQueryListListener} cb - Function called with media query result
    	 * @param  {String} mq - Media query expression
    	 */
    	function onMatch(cb, mq) {
    		var mql = getMql(mq);

    		if (mql) {
    			mql.addListener(function(m) {
    				if (m.matches) {
    					return cb();
    				}
    			});
    		}
    	}

    	/**
    	 * Registers a callback on a MediaQueryList called when a media query
    	 * is NOT matched.
    	 *
    	 * @param  {MediaQueryListListener} cb - Function called with media query result
    	 * @param  {String} mq - Media query expression
    	 */
    	function onUnmatch(cb, mq) {
    		var mql = getMql(mq);

    		if (mql) {
    			mql.addListener(function(m) {
    				if (!m.matches) {
    					return cb();
    				}
    			});
    		}
    	}

    	/**
    	 * Registers a callback on a MediaQueryList called when a media query
    	 * is matched.
    	 *
    	 * @deprecated Use onMatch instead
    	 * @param  {MediaQueryListListener} cb - Function called with media query result
    	 * @param  {String} mq - Media query expression
    	 */
    	function onMobile(cb, mq) {
    		return onMatch(cb, mq);
    	}

    	/**
    	 * Registers a callback on a MediaQueryList called when a media query
    	 * is NOT matched.
    	 *
    	 * @deprecated Use onUnmatch instead
    	 * @param  {MediaQueryListListener} cb - Function called with media query result
    	 * @param  {String} mq - Media query expression
    	 */
    	function onDesktop(cb, mq) {
    		return onUnmatch(cb, mq);
    	}

    	/**
    	 * Returns a MediaQueryList listening to a given media query.
    	 *
    	 * @param  {String} mq - Media query expression
    	 * @return {MediaQueryList}
    	 */
    	function getMql(mq) {
    		if (!window.matchMedia) { return null; }

    		// default mq if override isn't provided
    		var mq = mq || config.defaultMediaQuery;

    		// remove whitespace from mq
    		mq = overwatch.util.removeWhitespace(mq);

    		// return cached mql if exists, otherwise create new one and return it
    		return mqlCache[mq] || registerMql(mq);
    	}

    	/**
    	 * Registers and returns a MediaQueryList listening to a given media query.
    	 *
    	 * @private
    	 * @param  {String} mq - Media query expression
    	 * @return {MediaQueryList}
    	 */
    	function registerMql(mq) {
    		// remove whitespace from mq
    		mq = overwatch.util.removeWhitespace(mq);

    		// cache new mql
    		return mqlCache[mq] = window.matchMedia(mq);
    	}

    	/**
    	 * Interface
    	 * @see http://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
    	 */
    	return {
    		supported: (typeof window.matchMedia === "function"),
    		config: config,
    		onOrientationChange: onOrientationChange,
    		onMatch: onMatch,
    		onUnmatch: onUnmatch,
    		onMobile: onMobile,
    		onDesktop: onDesktop,
    		getMql: getMql
    	};

    };

    window.MediaQuery = MediaQuery();

}(window, window.overwatch, window.Utilities));
